module.exports = __webpack_public_path__ + "img/lg-為什麼選擇了做甜點.f251823a.svg";